<template>
    <div>
        The process of switching to your new supplier <span v-if="currentPropertyAddress">at {{currentPropertyAddress}}</span> has started. We have passed your details to them and they
        will be in touch to complete the switch.
        <hr>
        
        <button type="button" class="btn btn-outline-info btn-lg float-right"
                @click="$refs.tariffModal.show(notification.payload.tariff_id)">View new tariff details
        </button>
        <tariff-details-modal ref="tariffModal"/>
    </div>
</template>

<script>

import TariffDetailsModal from "@/components/profile/TariffDetailsModal";
import api from "@/utils/api";

export default {
    name: "SwitchInProgress",
    props: {
        notification: Object
    },
    components: {TariffDetailsModal},
    data() {
        return {
            currentPropertyAddress: null
        }
    },
    mounted() {
        let that = this;
        api.getRecommendation(this.notification.payload.recommendation_id, {
            recommendations: {fields: ['property']},
            properties: {fields: ['currentPropertyAddress']}
        }).then(response => {
            that.currentPropertyAddress = response.data.data.property.currentPropertyAddress
        })
    }
    
}
</script>

<style scoped>

</style>
